import styled from "styled-components";

export const StyledSelect = styled.select`
  max-width: 250px;
  width: 100%;
  flex-grow: 1;
  height: 40px;
  background: ${({ theme }) => theme.default.color.backgrounds.white};
  color: ${({ theme }) => theme.default.color.text.dark};
  padding: 4px 24px;
  font-size: 16px;
  border-radius: 32px;
  border: 1px solid ${({ theme }) => theme.default.color.text.light};

  &:focus {
    outline: none;
  }
  background: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="%23272727" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>')
    #fff no-repeat 99% 50%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;

  option {
    color: ${({ theme }) => theme.default.color.text.dark};
    background:${({ theme }) => theme.default.color.backgrounds.white};
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
`;

export const StyledLabel = styled.p`
  font-weight: bold;
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  span {
    color: ${({ theme }) => theme.default.color.primary};
  }
`;

export const CheckBoxWrapper = styled.div`
  width: 100%;
`;

export const Selectrapper = styled.div`
  display: flex;
  width: 100%;
`;
